module.exports = __webpack_public_path__ + "ff9c700b55ba2770a2f27edec879d790.svg";